<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item v-if="!row" label="授权类型">
        <el-select v-model="form.type">
          <el-option v-for="item in licenseType" :key="item.id" :value="item.id" :label="item.msg"></el-option>
        </el-select>
      </el-form-item>
      <template v-if="row">
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status">
            <el-option v-for="item in serverStatus" :key="item.id" :value="item.id" :label="item.msg"/>
          </el-select>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="可使用天数" prop="use_days">
          <el-input-number v-model="form.use_days" :min="1" :max="9999999" :step="1"/>
        </el-form-item>
        <el-form-item label="生成授权数" prop="count">
          <el-input-number v-model="form.count" :min="1" :max="9999999" :step="1"/>
        </el-form-item>
      </template>
      <el-form-item label="备注">
        <el-input v-model.trim="form.remark" clearable :maxlength="128"/>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty} from "@utils/validate"
  import {serverStatus, licenseType} from "@utils/formatList"
  export default {
    name: "ServerOperate",
    props: {dialogData: Object},
    data() {
      return {
        serverStatus,
        licenseType,
        form: {
          type: "ai",
          use_days: "",
          count: "",
          status: "",
          remark: "",
        },
        rules: {
          use_days: [inputEmpty("可使用天数", ["blur", "change"])],
          count: [inputEmpty("生成授权数", ["blur", "change"])],
        },
        row: this.dialogData.row,
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.form};
            let res = await this.$Http.addServerLicense(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        Object.entries(this.form).forEach(([key, value]) => value !== row[key] && (nv[key] = value));
        if (Object.keys(nv).length) {
          this.$refs["form"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该授权码", async () => {
                nv.server_license_id = row.id;
                let res = await this.$Http.reviseServerLicense(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改");
        }
      },
    }
  }
</script>

<style scoped>

</style>
